import { User } from 'firebase/auth';
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface IAuthStore {
  user: User | null;
  setUser: (by: User | null) => void;
  idFavorite: string;
  setIdFavorite: (id: string) => void;
}

export const useAuthStore = create<IAuthStore>()(
  devtools(
    persist(
      (set) => ({
        user: null,
        idFavorite: '',
        setUser: (v) => set(() => ({ user: v })),
        setIdFavorite: (v) => set(() => ({ idFavorite: v }))
      }),
      {
        name: 'user-storage'
      }
    )
  )
);
